import { getLastDayofMonthBeforeBirthdayFromEmployeeId, isSameOrBefore } from '@fora-monorepo/date-utils';
import { MAX_AGE_STARTDATE } from '@fora-monorepo/employer-my-pages-input-validation';
import { ValidationResult, ValidationRule } from '@foradevelopment/fora-ui';

/** Startdate must be before the last day of the month before they turn 100 */
export const isDateBeforeAllowedMaxAge =
  (errorMessage: string, employeeId: string): ValidationRule =>
  (value: string): ValidationResult => {
    // last day of the month before they turn 100 (MAX_AGE_STARTDATE + 1)
    const maxAgeRestrictionDate = getLastDayofMonthBeforeBirthdayFromEmployeeId(employeeId, MAX_AGE_STARTDATE + 1);

    const isValid = isSameOrBefore(value, maxAgeRestrictionDate);
    return { error: !isValid, errorMessage };
  };
